module.exports = __webpack_public_path__ + "img/elsalto.872ba43f.png";